import { GetExperienceResponseBodyType } from "@intelligems/ig-types/functions/experiences/get-experience";
import { api } from "@src/api/api";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

const fetchShareExperience = async (
  experienceId: string
): Promise<GetExperienceResponseBodyType> => {
  const resp = await api.get<GetExperienceResponseBodyType>(
    `/v2/experiences/${experienceId}`
  );
  return resp.data;
};

export const useShareExperience = (
  experienceId: string | undefined,
  shareToken: string | null
): UseQueryResult<GetExperienceResponseBodyType, Error> => {
  return useQuery({
    queryKey: ["share-experience", experienceId, shareToken],
    queryFn: async () => {
      if (!experienceId) {
        throw new Error(
          "experienceId is required for fetching share experience"
        );
      }
      return fetchShareExperience(experienceId);
    },
    enabled: Boolean(experienceId && shareToken),
    retry: false,
    meta: {
      onError: {
        401: "ignore",
        403: "ignore",
        404: "ignore",
        any: "ignore",
      },
    },
  });
};
